module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.ea0ca9a9.jpeg";